export default __webpack_public_path__ + "static/media/gst_summary_without_sku.84f169a9.png";